import { combineReducers } from 'redux'

import index from './reducers/index'
import forms from './reducers/forms'
import tenantFinder from './reducers/tenantFinder'

const root = combineReducers({
  index,
  forms,
  tenantFinder
})

export default (state, action) => {
  return root(state, action)
}
